/* eslint-disable no-lonely-if */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import DepartureCItyPopover from '../DepartureCItyPopover/DepartureCItyPopover';
import TouristsPopover from '../TouristsPopover/TouristsPopover';
import DestinationPopover from '../DestinationPopover/DestinationPopover';
import DayPickerComponent from '../DayPickerComponent/DayPickerComponent';
import NightsPopover from '../NightsPopover/NightsPopover';
import {
  FROM_ID,
  TO_ID,
  WHEN_ID,
  NIGHTS_ID,
  TOURISTS_ID,
} from '../../../Utils/Constants/HomePageConstants';

class Popover extends React.Component {
  selectPopover = (id) => {
    switch (id) {
      case FROM_ID:
        return <DepartureCItyPopover />;
      case TO_ID:
        return <DestinationPopover />;
      case WHEN_ID:
        return <DayPickerComponent />;
      case NIGHTS_ID:
        return <NightsPopover />;
      case TOURISTS_ID:
        return <TouristsPopover />;
      default:
        return null;
    }
  };

  getClass = (isDesctop, id) => {
    if (isDesctop) {
      return 'sf_popover_w';
    } else {
      if (id === TO_ID || id === TOURISTS_ID) {
        return 'sf_left_shift_to_popover_w';
      } else if (id === FROM_ID) {
        return 'sf_t_from_popover_w';
      } else {
        return 'sf_t_popover_w';
      }
    }
  };

  render() {
    const { id, isDesctop } = this.props;
    const popover = this.selectPopover(id);

    return (
      <div className={`popover ${this.getClass(isDesctop, id)}`}>{popover}</div>
    );
  }
}

Popover.propTypes = {
  id: PropTypes.string.isRequired,
  isDesctop: PropTypes.bool,
};

Popover.defaultProps = {
  isDesctop: false,
};

export default Popover;
